import { CellClassParams, ColDef } from 'ag-grid-community';
import { t } from 'i18next';
import { FieldErrors } from 'react-hook-form';

import { COMPONENT_EMPTY_NAME } from 'bom/constants';
import { BomPartType } from 'bom/enums';
import { DEFAULT_PLACEHOLDER } from 'core/constants';

import { QuantityCell } from './cells';
import { ICopyMoveToElementData } from './types';

export const getColumnDefs = (errors: FieldErrors<ICopyMoveToElementData>): ColDef[] => {
  return [
    {
      colId: 'partNumber',
      headerName: t('headerPartNumber'),
      field: 'partNumber',
      cellStyle: { fontWeight: 'bold' },
      flex: 2,
    },
    {
      colId: 'description',
      headerName: t('headerDescription'),
      field: 'description',
      flex: 3,
    },
    {
      colId: 'componentName',
      headerName: t('headerComponentName'),
      field: 'componentName',
      valueGetter: ({ data }) =>
        data.type !== BomPartType.COMPONENT &&
        data.componentName !== COMPONENT_EMPTY_NAME &&
        data.componentName
          ? data.componentName
          : DEFAULT_PLACEHOLDER,
      cellStyle: { fontStyle: 'italic' },
      flex: 2,
    },
    {
      colId: 'uom',
      headerName: t('headerUom'),
      field: 'uom',
      flex: 1,
    },
    {
      colId: 'currentQuantity',
      headerName: t('headerCurrentQuantity'),
      field: 'currentQuantity',
      flex: 1,
    },
    {
      colId: 'quantity',
      headerName: t('headerNewQuantity'),
      field: 'quantity',
      cellClass: ({ rowIndex }: CellClassParams) => {
        if (errors && errors[rowIndex] && errors[rowIndex]) {
          return 'dangerBackground';
        }

        return '';
      },
      cellRenderer: QuantityCell,
      flex: 1,
    },
  ];
};
